import * as types from "./types";

export function loadingStart() {
  return {
    type: types.REQUEST_START,
  };
}

export function loadingSuccess(data) {
  return {
    type: types.REQUEST_SUCCESS,
    data,
  };
}

export function loadingFailed(error) {
  return {
    type: types.REQUEST_FAILED,
    error,
  };
}

export function loadingWarning(detail) {
  return {
    type: types.REQUEST_WARNING,
    detail,
  };
}

export function resetValues() {
  return {
    type: types.RESET_VALUES,
  };
}

export function temporaryResetGeneral() {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(resetValues());
    }, 2600);
  };
}

export function failed(message) {
  return (dispatch) => {
    dispatch(loadingFailed(message));
    dispatch(temporaryResetGeneral());
  };
}

export function success(message) {
  return (dispatch) => {
    dispatch(loadingSuccess(message));
    dispatch(temporaryResetGeneral());
  };
}
